<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="soas/receiveDetail"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="otherBtn">
        <el-button v-if="limits.createAuth" type="primary" @click="createOrder">创建对账单</el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="采购订单">
            <el-input
                v-model.trim="filter.evaluate"
                type="textarea"
                autosize
                placeholder="请输入采购订单号"
                clearable/>
          </el-form-item>
          <el-form-item label="送货单号">
            <el-input
                v-model.trim="filter.asnNo"
                type="textarea"
                autosize
                placeholder="请输入送货单号"
                clearable/>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.partNo" placeholder="请输入物料编号" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.partNameSpec" placeholder="请输入物料名称" clearable/>
          </el-form-item>
          <el-form-item label="采购组">
            <el-input v-model.trim="filter.buyUserName" placeholder="请输入采购组" clearable/>
          </el-form-item>
          <el-form-item label="供应商编号">
            <el-input v-model.trim="filter.supplierNo" placeholder="请输入供应商编号" clearable/>
          </el-form-item>
          <el-form-item label="供应商名称">
            <el-input v-model.trim="filter.supplierName" placeholder="请输入供应商名称" clearable/>
          </el-form-item>
          <el-form-item label="对账状态">
            <el-select v-model.trim="filter.soaStatus" placeholder="请选择对账状态">
              <el-option label="未对账" :value="'未对账'"/>
              <el-option label="部分对账" :value="'部分对账'"/>
              <!--              <el-option label="已对账" :value="'已对账'"/>-->
            </el-select>
          </el-form-item>
          <el-form-item label="创建日期">
            <el-date-picker
                v-model="createDate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="createDateChange"
            />
          </el-form-item>
          <el-form-item label="到货日期">
            <el-date-picker
                v-model="arriveDate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="arriveDateChange"
            />
          </el-form-item>
        </el-form>
      </template>
    </viewtable>
    <reconcile-order-edit ref="reconcileOrderEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import ReconcileOrderEdit from "@/views/PurchaseOrderManager/ReconcileOrder/ReconcileOrderEdit";

  export default {
    name: "CreateReconcileOrder",
    components: {viewTable, ReconcileOrderEdit},
    data() {
      return {
        limits: {
          createAuth:this.$auth(450),
        },
        filter: {
          evaluate: "",
          asnNo: "",
          partNo: "",
          partNameSpec: "",
          soaStatus: "未对账",
          straightMark: "",
          buyUserName: "",
          supplierNo: "",
          supplierName: "",
          arriveDateEnd: "",
          arriveDateBegin: "",
          createDateBegin: "",
          createDateEnd: "",
        },
        selection: [],
        arriveDate: "",
        createDate: "",
        columnsProperty: [
          {
            tooltip: true,
            key: "asnNo",
            width: 120,
            align: "center",
          },
          {
            tooltip: true,
            key: "asnRowIndex",
            width: 120,
            align: "center",
          },
          // {
          //   key: "action",
          //   align: "center",
          //   width: 300,
          //   slot: "action",
          //   fixed: "right",
          // },
        ],
      };
    },
    mounted() {
    },

    methods: {
      selectHandle(selection) {
        this.selection = selection;
      },

      createOrder() {
        if (this.selection.length > 800) {
          this.$message.error("对账单不可超过800条");
        } else if(this.selection.length === 0) {
          this.$message.error("请选择对账单");
        } else {
          console.log(this.$refs.reconcileOrderEdit);
          this.$refs.reconcileOrderEdit.open(0, this.selection);
        }
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      arriveDateChange(value) {
        if (value) {
          this.filter.arriveDateBegin = value[0];
          this.filter.arriveDateEnd = value[1];
        } else {
          this.filter.arriveDateBegin = "";
          this.filter.arriveDateEnd = "";
        }
      },

      createDateChange(value) {
        if (value) {
          this.filter.createDateBegin = value[0];
          this.filter.createDateEnd = value[1];
        } else {
          this.filter.createDateBegin = "";
          this.filter.createDateEnd = "";
        }
      },

      resetHandle(filter) {
        this.filter = filter;
      },
    },
  };
</script>
